import PatientDoctorDocumentsTable from '../DoctorComponent/PatientDoctorDocumentsTable';
import { useDataUser } from '../../context/dataUserContext';

const PatientAssignedDocuments = () => {
    const { patientId } = useDataUser();

    return (
        <div className="space-y-6 px-2 md:px-0">
            <PatientDoctorDocumentsTable patientId={patientId} isDownload={true} />
        </div>
    );
};

export default PatientAssignedDocuments;
